"use client";

import React from "react";
import { FilePlus, RefreshCw } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const columns = [{
  icon: FilePlus,
  title: "Création de certification (RNCP ou RS)",
  description: "Vous portez un projet de certification ex nihilo, sans historique d'enregistrement. Cette démarche exige une réflexion stratégique approfondie sur la pertinence du projet, une ingénierie rigoureuse des référentiels et une capacité à démontrer l'opportunité et la valeur ajoutée de votre certification auprès de France Compétences.",
  accompagnement: "EFFET CONSEIL vous accompagne pour : construire des référentiels solides et différenciants, sécuriser la conformité de votre dossier, argumenter l'opportunité et la valeur d'usage de votre certification, tout en vulgarisant les exigences techniques pour vos équipes."
}, {
  icon: RefreshCw,
  title: "Renouvellement de certification existante",
  description: "Votre certification arrive à échéance et doit être renouvelée. Cette démarche impose de démontrer les évolutions du métier visé, l'adéquation des compétences certifiées avec les évolutions du marché du travail et la qualité de votre dispositif certifiant (taux de réussite, insertion professionnelle…).",
  accompagnement: "EFFET CONSEIL vous accompagne pour : actualiser vos référentiels en cohérence avec les évolutions du métier, valoriser les résultats obtenus depuis le précédent enregistrement, optimiser vos procédures de contrôle dans une logique d'amélioration continue et de transparence."
}];
export default function CreationVsRenouvellement() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="creation-vs-renouvellement" className="relative bg-[#E8E4DF] text-foreground py-20 lg:py-24 overflow-hidden">
      <div className="container max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div ref={headerRef} className={`max-w-4xl mx-auto text-center mb-14 lg:mb-20 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold tracking-tight mb-6 text-[#62751D]">
            Création ou renouvellement : deux démarches, une exigence commune
          </h2>
        </div>

        {/* Two columns */}
        <div ref={gridRef} className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {columns.map((col, i) => <div key={i} className={`transition-all duration-700 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full overflow-hidden rounded-xl border-t-4 border-t-[#62751D] border-l-0 border-r-0 border-b-0 bg-white shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <CardContent className="p-8 lg:p-10">
                  {/* Icon + Title */}
                  <div className="flex items-center gap-4 mb-6">
                    <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#62751D]/10 text-[#62751D] shrink-0">
                      <col.icon className="w-7 h-7" />
                    </div>
                    <h3 className="font-serif text-xl md:text-2xl font-bold text-[hsl(343,80%,35%)]">
                      {col.title}
                    </h3>
                  </div>

                  {/* Description */}
                  <p className="text-base leading-relaxed text-[hsl(210,10%,23%)] mb-6">
                    {col.description}
                  </p>

                  {/* Accompagnement */}
                  <div className="bg-[#62751D]/5 rounded-lg p-5 border-l-4 border-l-[#62751D]">
                    <p className="text-base leading-relaxed text-[hsl(210,10%,23%)] font-semibold">
                      {col.accompagnement}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}